// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'analytics-good-solid';

export const Component = () => (
  <path d='M20.93 3.592C18.535 1.198 15.662 0 12.26 0c-3.4 0-6.273 1.198-8.668 3.592C1.198 5.987 0 8.86 0 12.261a12.6 12.6 0 0 0 .623 3.88l.096-.096L5.89 10.92c.24-.239.432-.239.67 0l3.64 3.592 6.658-6.657h-6.657c-.336 0-.527-.143-.527-.478 0-.383.191-.575.527-.575h7.806c.047-.048.144 0 .287.047.144.048.24.192.288.335.047.048.047.144.047.288v7.71c0 .384-.143.576-.478.576-.336 0-.48-.192-.48-.575V8.526l-7.135 7.088c-.24.24-.48.24-.719 0l-3.592-3.592-5.173 5.124c.91 2.203 2.395 3.975 4.454 5.316 2.012 1.39 4.263 2.06 6.753 2.06 3.4 0 6.274-1.198 8.669-3.592 2.394-2.395 3.592-5.268 3.592-8.67 0-3.4-1.198-6.273-3.592-8.668Z' />
);

export const viewBox = '0 0 25 25';
